import { render, staticRenderFns } from "./SingleForm.vue?vue&type=template&id=f5534674&scoped=true"
import script from "./SingleForm.vue?vue&type=script&lang=js"
export * from "./SingleForm.vue?vue&type=script&lang=js"
import style0 from "./SingleForm.vue?vue&type=style&index=0&id=f5534674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5534674",
  null
  
)

export default component.exports